import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogos, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo, getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';

const COD_BOTON_SALDOCONTABLE = '010601';

class FormCli06  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null,
            cliente_sel: null,
            tipoSaldo: 'CLI',
            isVisibleBotonSaldoContab: false,
            tipoUsuario: null, //TipoUsuario === 3 => Vendedor
            paramVendedor: null, //=> 3
            diasConsultaVen: null,
        };

        this.impRptEstadoCuenta = this.impRptEstadoCuenta.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.cantVisitasCliente = this.cantVisitasCliente.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 4 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback);
        }
    }

    componentDidMount(){
        let usuario = getItemDatosSesion('usuario');
        Promise.all([
            cargarPermisoBoton(COD_BOTON_SALDOCONTABLE, usuario),
            cargarCatalogos('PARAMVENDEDOR'),
            cargarCatalogos('DIASCONSULVEN'),
            this.props.generar_LogAuditoriaIngresoForm('0106')
         ])
        .then(([ configBotonSaldoContab, paramVendedor, paramDiasContultaVen ]) => {
            let fechaProceso = getFechaProcesoPorModulo('01');
            let isVisibleBotonSaldoContab = false;

            if(configBotonSaldoContab.display==='block'){
                isVisibleBotonSaldoContab = true;
            }
        
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
                
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta, isVisibleBotonSaldoContab,
            tipoUsuario: this.props.tipoUsuario, paramVendedor: parseInt(paramVendedor[0].value,10), 
            diasConsultaVen: parseInt(paramDiasContultaVen[0].value,10)});
        })
        .catch(error=>{
            alert(error);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0106');
    }

    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');

        //Evaluacion Año
        if(parseInt(fechaPart[2],10)<=parseInt(fechaPartProceso[2],10)){
            respuesta = true;
        }else{
            respuesta = false;
        }

        return respuesta;
    }

    impRptEstadoCuenta(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        let fechaProceso = getFechaProcesoPorModulo('01');
        if(this.state.tipoUsuario === this.state.paramVendedor){
            let fechaMaxVen = moment(fechaProceso,'DD/MM/YYYY').subtract(this.state.diasConsultaVen, 'days');
            let result = fechaMaxVen.isAfter(this.state.fechaDesde);
            if(result === true){
                errorAnio = true;
                continuar = false;
                error=error+`- La fecha desde no puede ser menor del: ${formatearFechaMoment_a_String(fechaMaxVen)}\n`;
            }

            if(this.state.cliente_sel===null){
                continuar = false;
                error=error+`- Seleccione un cliente antes de continuar\n`;
            }
        }
        
        //Validacion por mismo AÑO Y MES DEL INTERVALO DE FECHAS
        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaDesde)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha desde no esta dentro del año vigente.\n';
        }

        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaHasta)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        }

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            let urlRpt = this.state.tipoSaldo==='CLI'?'&rpt=98':'&rpt=17';

            urlRpt += '&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);

            if(this.state.cliente_sel!==null){
                urlRpt += '&param3='+this.state.cliente_sel.value;
            }
            visualizarReporteEnPdf(urlRpt);
        }else{
            alert(error);
        }
    }

    limpiar(){        
        let fechaProceso = getFechaProcesoPorModulo('01');
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta, cliente_sel: null, tipoSaldo: 'CLI'});
    }

    cantVisitasCliente(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        var data = {};

        let fechaProceso = getFechaProcesoPorModulo('01');

        if(this.state.cliente_sel===null){
            continuar = false;
            error = error+"- Debe seleccionar un cliente para continuar.\n";
        }

        //Validacion por mismo AÑO Y MES DEL INTERVALO DE FECHAS
        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaDesde)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha desde no esta dentro del año vigente.\n';
        }

        if(this.validacionFechaTrabajo(fechaProceso, this.state.fechaHasta)===false){
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no esta dentro del año vigente.\n';
        }

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            data.fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde)
            data.fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta)
            let config_request = {
                method: 'POST',
                url: '/clientes/'+this.state.cliente_sel.value+'/visitas',
                data
            }

            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=> {
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg);
            })
            .catch((error)=>{   
                this.props.cambiar_VisualizacionLoading(false);             
                alert(error.response?error.response.data.msg:error.message); 
            });
        }else{
            alert(error);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Estado de Cuenta</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm>Cliente:</LabelForm>
                                <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value, cheques: []})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Fecha Desde:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Fecha Hasta:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <ContainerCol className='col-sm-8'>
                            <LabelForm>Tipo de Saldo:</LabelForm>                                
                            <div>
                                <LabelRadio className='radio-inline'><input type='radio' value='CLI' name='tipoSaldo' checked={this.state.tipoSaldo==='CLI'}
                                    onChange={this.handleInputChange}/> Saldo Cliente</LabelRadio>
                                {this.state.isVisibleBotonSaldoContab?
                                    <LabelRadio className='radio-inline'><input type='radio' value='CON' name='tipoSaldo' checked={this.state.tipoSaldo==='CON'}
                                        onChange={this.handleInputChange}/> Saldo Contable</LabelRadio>
                                :null}
                            </div>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.impRptEstadoCuenta}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                                <button type="button" className='btn btn-success btn-sm' disabled={this.state.cliente_sel===null?true:false} onClick={this.cantVisitasCliente}><i className="fa fa-address-book-o fa-lg"></i> Cant. Visitas</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
} 

const mapStateToProps = ((state) => {
    return { tipoUsuario: state.sesion.valoresSesionForm.TipoUsuario }
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCli06);